import {
  FormLabel,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react';
import LZString from 'lz-string';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { Button } from '@revelio/ui';

import { useFilterContext } from '../../../filters/contexts/FilterProvider';
import { buildPathFromPage } from '../../../utils/routing-helpers';
import modalStyles from '../../Modal/themedModal.module.css';
import type { Page } from '../../PageConfigProvider/types';
import { ParameterEntitiesEditor } from './ParameterEntitiesEditor';
import { parametersFromPageConfig } from './parameters';

export const EnterParametersModal = ({
  isOpen,
  onClose,
  navigateOnSubmit,
  pageConfig,
}: {
  isOpen: boolean;
  onClose: () => void;
  navigateOnSubmit: boolean;
  pageConfig: Page;
}) => {
  const [canCreateReport, setCanCreateReport] = useState(false);
  const { activeFilterMap } = useFilterContext();
  const navigate = useNavigate();
  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="2xl">
      <ModalOverlay />
      <ModalContent className={modalStyles.content}>
        <ModalHeader color="text.primary">
          {pageConfig.name ? `Run ${pageConfig.name}` : 'Run Custom Report'}
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormLabel fontWeight="semibold" color="text.primary" mb={3}>
            Parameters
          </FormLabel>
          <ParameterEntitiesEditor
            parameters={parametersFromPageConfig(pageConfig)}
            onCanCreateReport={setCanCreateReport}
            showResetCompetitorsButton
          />
        </ModalBody>
        <ModalFooter>
          <Button
            size="sm"
            disabled={!canCreateReport}
            color="primary"
            onClick={() => {
              onClose();
              if (navigateOnSubmit) {
                const entries = Array.from(activeFilterMap.entries());

                const serialized = LZString.compressToEncodedURIComponent(
                  JSON.stringify(entries)
                );
                const basePath = buildPathFromPage(pageConfig);
                const to =
                  entries.length > 0
                    ? `${basePath}?filters=${serialized}`
                    : basePath;
                navigate(to);
              }
            }}
          >
            Submit
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
